import { ADVISOR_SESSION_FRAGMENT } from '@src/gql/fragments/AdvisorSessionFragment'
import { gql } from '@src/lib/gql'

/**
 * Badge count for the Sessions rail: non-terminal sessions in either role.
 * `pageSize: 1` — only `pagination.itemCount` is read.
 */
export const ADVISOR_OPEN_SESSION_COUNT = gql`
  query AdvisorOpenSessionCount {
    advisorSessions(
      role: "ALL"
      statusKeys: [
        "pending"
        "verify_schedule_with_expert"
        "verify_schedule_with_seeker"
        "schedule_confirmed"
        "live"
      ]
      pageSize: 1
      page: 1
    ) {
      pagination {
        itemCount
      }
    }
  }
`

export const ADVISOR_SESSIONS = gql`
  query AdvisorSessions($role: String, $statusKeys: [String], $pageSize: Int, $page: Int) {
    advisorSessions(role: $role, statusKeys: $statusKeys, pageSize: $pageSize, page: $page) {
      items {
        ...AdvisorSessionFragment
      }
      pagination {
        itemCount
        hasNextPage
        page
        pageSize
        pageCount
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`
